import { useCallback } from "react";
import { usePostHog } from "posthog-react-native";

type InterestEvent = {
  featureId: string;
  featureType: "program" | "supplement" | "test" | "product" | "therapy";
  featureName: string;
};

export function useInterestCapture() {
  const posthog = usePostHog();

  const capture = useCallback(
    ({ featureId, featureType, featureName }: InterestEvent) => {
      posthog.capture("feature_interest_expressed", {
        feature_id: featureId,
        feature_type: featureType,
        feature_name: featureName,
      });
    },
    [posthog],
  );

  return { capture };
}
